const NAME = "TYPES_OF_ONBOARDING_ACTIONS";

export default NAME;
